import { Link } from "react-router-dom";

export default function NotFoundPage() {

    return (
        <div className="min-h-screen flex flex-col items-center justify-center px-4 py-16 text-center">
            <h1 className="text-6xl font-bold text-indigo-600 mb-4">404</h1>
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">Oops! This page is lost in the shadows. 🥷</h2>
            <p className="text-gray-600 mb-6">
                The page you're looking for doesn’t exist. Perhaps it was a stealthy ninja move.
            </p>
            <Link
                to="/"
                className="inline-block bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-700 transition"
            >
                Back to Home
            </Link>
        </div>
    );
}
